import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_TEAMS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import getTeamModel from '@/store/modules/models/team'

const teams = {
  namespaced: true,
  state: buildInitialState({
    teamsList: [],
    ...getTeamModel()
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setTeamsList: (state, teamsList) => {
      state.teamsList = teamsList
    },
    setTeam (state, team) {
      state.id = team.id
      state.teamName = team.teamName
      state.managerId = team.managerId
      state.managerName = team.managerName
      state.teamMembers = team.teamMembers
    }
  },
  actions: {
    getTeams: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting teams, please wait...' })

      return api.doGet({ path: PATH_TEAMS, parameters: filters })
        .then(json => json.data)
        .then(teamsList => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTeamsList', teamsList)
          hideProgressModal({ dispatch })
          return teamsList
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to select teams')
        })
    },
    saveTeam ({ commit, dispatch }, team) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving team, please wait...' })
      return api.doPost({ path: PATH_TEAMS, data: team })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save team')
          }

          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Team saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to save team')
        })
    },
    updateTeam ({ commit, dispatch }, team) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Updating team, please wait...' })
      return api.doPut({ path: PATH_TEAMS, data: team })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to update team')
          }

          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Team updated')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to update team')
        })
    },
    deleteTeam ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting team, please wait...' })
      return api.doDelete({
        path: PATH_TEAMS,
        parameters: Object.assign({}, { id: id })
      })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to delete team')
          }

          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Team deleted')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to delete team')
        })
    }
  }
}

export default teams
